import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HeadersModule, IconsModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { CmsModule } from '@fcom/cms/components/cms.module';
import { ComponentsModule, NavigationTriggerModule } from '@fcom/common/components';
import { DirectiveModule } from '@fcom/common/directives/directive.module';
import { FinFormsModule } from '@fcom/common/forms';
import { GtmModule } from '@fcom/common/gtm/gtm.module';
import { LoginModule } from '@fcom/common/login';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { LocationsModule } from '@fcom/locations';
import { TabsModule } from '@fcom/common-booking/modules/tabs';
import { CommonBookingAncillaryService } from '@fcom/common-booking/modules/ancillaries/services';
import { CommonBookingComponentsModule } from '@fcom/common-booking/common-booking.module';
import { BookingSummaryModule } from '@fcom/common-booking/components/booking-summary/booking-summary.module';
import { FragmentService } from '@fcom/common';
import { DataCloudModule } from '@fcom/common/datacloud';

import { BookingStoreModule } from './store/booking.store.module';
import { BookingCommonModule } from './modules/common/booking-common.module';
import { BookingRoutingComponent } from './components/booking-routing/booking-routing.component';
import { BookingRoutesModule } from './booking.routes';
import { BookingCartService, BookingQueueService, BookingService } from './services';
import { BookingGtmService } from './services/booking-gtm.service';
import { BookingNotificationModule } from './components/booking-notification/booking-notification.module';
import { BookingWidgetModule } from '../booking-widget/booking-widget.module';
import { StepperV2Module } from '../ui-components/components/stepper-v2/stepper-v2.module';

@NgModule({
  providers: [
    BookingCartService,
    BookingService,
    BookingGtmService,
    CommonBookingAncillaryService,
    BookingQueueService,
    FragmentService,
  ],
  imports: [
    BookingStoreModule,
    BookingRoutesModule,
    BookingCommonModule,
    CommonBookingComponentsModule,
    TabsModule,
    CmsModule,
    CommonModule,
    ComponentsModule,
    DirectiveModule,
    FinFormsModule,
    GtmModule,
    DataCloudModule,
    LoginModule,
    NavigationTriggerModule,
    PipesModule,
    RouterModule,
    UiTranslateModule,
    HeadersModule,
    IconsModule,
    LocationsModule,
    BookingNotificationModule,
    BookingSummaryModule,
    BookingWidgetModule,
    StepperV2Module,
  ],
  declarations: [BookingRoutingComponent],
})
export class BookingModule {}
